// extracted by mini-css-extract-plugin
export default {"moveBuildStartBody":"MoveBuildStart_moveBuildStartBody__DPADv","buttonContainer":"MoveBuildStart_buttonContainer__UHSXk"};